import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import { connectReferral, login, verify } from "@network/Auth/apiAuth";
import { useDispatch } from "react-redux";
import { updateUser } from "@store/authReducer";
import { updateNotice } from "@store/noticeReducer";
import { useNavigate, useParams } from "react-router-dom";
import { Errors } from "@const/error";
import { RequestLogin } from "@network/Auth/type";
import { routes } from "@const/routes";
import PopUp from "@components/PopUp";
import { PopupWrapper } from "@components/Footer";
import { EncryptService } from "@utils/encrypt.service";
import DecryptedData from "@utils/decrypdata.service";
import { useImagePath } from "@components/HeaderBar/imageTheme";
import step1Icon from "@assets/img/step1-icon.svg"
import step2Icon from "@assets/img/step2-icon.svg"
import step3Icon from "@assets/img/step3-icon.svg"
import step4Icon from "@assets/img/step4-icon.svg"
import step5Icon from "@assets/img/step5-icon.svg"
import useThemeInitializer from "src/ThemeInitializer";
import PrivacyPolicy from "@components/Privacy-Policy";
import { trackUserEvent, trackFunnel } from "@utils/analytics";
import useAnalytics from "src/hooks/useAnalytics";


const privateKey = process.env.REACT_APP_PRIVATE_KEY as string;

const Login: React.FC = () => {
  const { id } = useParams();
  const [phone, setPhone] = useState<string | undefined>();
  const [otp, setOtp] = useState<string>();
  const [isCheck, setIsCheck] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [showTermAndCondition, setShowTermAndCondition] =
    useState<boolean>(false);
  const [showConsentForm, setShowConsentForm] = useState<boolean>(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] =
    useState<boolean>(false);
  const [showContactUs, setShowContactUs] = useState<boolean>(false);
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [payloadFromGift, setPayloadFromGift] = useState<any>();
  const [isInValidPhone, setIsInValidPhone] = useState<boolean>(false);
  const [showOtp, setShowOtp] = useState<boolean>(false);
  // const [isResend, setIsResend] = useState<boolean>(false);
  const [timer, setTimer] = useState<number>(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const imagePath = useImagePath();
  const consentChecked = localStorage.getItem("consentChecked") === "true";
  const [consent, setConsent] = useState(consentChecked);

  // const [raffleData, setRaffleData] = useState<any[]>([])
  // const [loading, setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [isVerifying, setIsVerifying] = useState<boolean>(false);
  const [isSendingOtp, setIsSendingOtp] = useState<boolean>(false);
  const [otpScreenOpenTime, setOtpScreenOpenTime] = useState<number>(0);
  const { fetchTheme, theme } = useThemeInitializer();
  const { trackButtonClick } = useAnalytics();
  // const featureItems: string[] = [
  //   '100% FREE to play - no hidden costs ✅',
  //   'Genuine Dabur products guaranteed for you ✅',
  //   'Play daily for more chances to win ✅',
  //   'Instant digital rewards in your account ✅',
  // ];

  const steps = [
    {
      label: 'Step 1',
      title: 'Sign In / Sign Up',
      desc: 'Create your account or log in to get started.',
      icon: step1Icon,
    },
    {
      label: 'Step 2',
      title: 'Get Tickets',
      desc: 'Answer questions, complete your profile, or invite friends to earn tickets.',
      icon: step2Icon,
    },
    {
      label: 'Step 3',
      title: 'Enter Raffles',
      desc: 'Use your tickets to join the raffles you like.',
      icon: step3Icon,
    },
    {
      label: 'Step 4',
      title: 'Pick Your Lucky Number',
      desc: 'Enter the game by choosing the number you believe will win.',
      icon: step4Icon,
    },
    {
      label: 'Step 5',
      title: 'Win & Claim Your Reward',
      desc: 'If you win, follow the steps to redeem your prize.',
      icon: step5Icon,
    },
  ];
  // let imageurls: any[] = []

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer - 1 === 0) {
        // setIsResend(true);
        clearInterval(interval);
      }
      setTimer((prevTimer) => (prevTimer - 1 >= 0 ? prevTimer - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    const giftCode = localStorage.getItem("giftCode");
    if (giftCode) {
      const encrypt = new EncryptService();
      const payload: any = encrypt.decryptUseAES(
        giftCode,
        privateKey,
        DecryptedData
      );
      const parsedPayload = JSON?.parse(payload);
      setPayloadFromGift(parsedPayload);
    }

    // Handle referral ID from URL
    if (id) {
      localStorage.setItem('referralId', id);
    }

    fetchTheme('landing');
  }, [id]);

  // const fetchRaffleData = async () => {
  //   try {
  //     const res = await getAllRaffleData();
  //     if (res.code === 200) {
  //       const mapped = res.data.map((item: any) => ({
  //         id: item.id,
  //         url: item.thumbnailImg ? 'https://wnnr.fsn1.your-objectstorage.com/' + item.thumbnailImg : item.bannerUrl,
  //       }));
  //       setRaffleData(mapped);
  //       setLoading(false);
  //     } else {
  //       setRaffleData([]);
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     setRaffleData([]);
  //     setLoading(false);
  //     console.error("Failed to fetch raffle data:", error);
  //   }
  // }

  // useEffect(() => {
  //   fetchRaffleData()
  // }, [])

  const onSend = async () => {
    if (!phone || !/^\d{10}$/.test(phone)) {
      setIsInValidPhone(true);
      setIsError(true);
      setErrorMsg("Please enter a valid phone number");
      return;
    }
    try {
      if (isError || isSendingOtp) return;
      setIsSendingOtp(true);
      trackFunnel.phoneNumberEntered();
      const res = await login({
        phone,
        ...(payloadFromGift ? { source: payloadFromGift.source } : {}),
      });
      if (res.status === "error") {
        setIsSendingOtp(false);
        trackFunnel.otpSent(false);
        return dispatch(
          updateNotice(
            {
              type: "ERROR",
              content: Errors[res.message]
                ? Errors[res.message]
                : Errors.SEND_OTP_ERROR,
            },
            dispatch
          )
        );
      }

      setShowOtp(true);
      setTimer(59);
      setIsSendingOtp(false);
      setOtpScreenOpenTime(Date.now());
      trackFunnel.otpSent(true);

      // Track OTP request
      trackButtonClick("request_otp", { phone_number_length: phone.length });
    } catch (error) {
      console.log(error);
      setIsSendingOtp(false);
    }
  };

  const onVerify = async () => {
    try {
      if (!otp || !isCheck || !phone) {
        setIsError(true);

        return;
      }

      setIsError(false);
      setIsVerifying(true);
      const verifyPayload: RequestLogin = {
        phone,
        otp,
        ...(payloadFromGift ? { source: payloadFromGift.source } : {}),
      };
      if (id) verifyPayload.invitedBy = Number(id);

      const res = await verify(verifyPayload);

      if (res.status === "error") {
        localStorage.removeItem("giftCode");
        setIsVerifying(false);
        trackFunnel.otpVerified(false, otpScreenOpenTime > 0 ? Date.now() - otpScreenOpenTime : undefined, res.message || "unknown");
        return dispatch(
          updateNotice(
            {
              type: "ERROR",
              content: Errors[res.message]
                ? Errors[res.message]
                : Errors.VERIFY_OTP_ERROR,
            },
            dispatch
          )
        );
      }

      const referralId = localStorage.getItem("referralId");
      if (referralId) {
        connectReferral(Number(referralId))
          .then(() => {
            dispatch(
              updateNotice(
                {
                  type: "SUCCESS",
                  content: "🎉 You and your friend both received 1 ticket! Welcome to WNNR!",
                },
                dispatch
              )
            );
          })
          .catch((err) => {
            console.log("Failed to connect referral:", err);
          });
      }


      localStorage.removeItem("giftCode");
      localStorage.removeItem("referralId");
      dispatch(updateUser(res.data));

      // Track OTP verified
      trackFunnel.otpVerified(true, otpScreenOpenTime > 0 ? Date.now() - otpScreenOpenTime : undefined);

      // Track user login/signup
      const isNewUser = res.data?.isNewUser || false;
      if (isNewUser) {
        trackUserEvent.signup(res.data?.user?.id || res.data?.id, "phone");
      } else {
        trackUserEvent.login(res.data?.user?.id || res.data?.id, "phone");
      }

      navigate(routes.dashboard);
    } catch (error) {
      console.log(error);
      setIsVerifying(false);
    }
  };

  const showTime = (timer: number) =>
    timer > 9 ? `00:${timer}` : `00:0${timer}`;

  useEffect(() => {
    if (!phone) {
      setIsInValidPhone(false);
      setIsError(false);
      setErrorMsg(null);
      return;
    }

    if (!/^\d{10}$/.test(phone)) {
      setIsError(true);
      setIsInValidPhone(true);
      setErrorMsg(phone.length === 10 ? "Phone number must be exactly 10 digits" : phone.length > 10 ? "Phone number cannot exceed 10 digits" : "Phone number must be 10 digits");
      return;
    }

    setIsInValidPhone(false);
    setIsError(false);
    setErrorMsg(null);

    if (!isCheck) {
      setIsError(true);
      return;
    }
    setIsError(false);
  }, [isCheck, phone]);

  const HandleConsent = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    if (checked) {
      localStorage.setItem("consentChecked", "true");
      setConsent(!!localStorage.getItem("consentChecked"))
      setIsCheck(true)
    } else {
      localStorage.removeItem("consentChecked");
      setConsent(!!localStorage.getItem("consentChecked"))
      setIsCheck(false)
    }
  }

  const HandleCheckbox = () => {
    if (consent) {
      setIsCheck(!isCheck)
    } else {
      setShowConsentForm(true)
    }
  }



  return (
    <div className="bg-[#EAF0D5] w-full">

      <div className="lg:container bg-[#EAF0D5] w-full px-4" style={{
        margin: "0 auto",
      }}>


        <div className="pt-10 md:pt-24"></div>
        <div>
          <div className="lg:px-5">
            {/* <Container> */}
            <div className="flex flex-col lg:flex-row gap-4 md:gap-6 lg:items-stretch">
              <div className="w-full lg:basis-[45%] flex">
                {showOtp ? (

                  <div className="bg-white border-3 border-[#4B975B] rounded-xl p-4 sm:p-6 md:p-7 lg:p-8 flex flex-col justify-around h-full transition-all duration-300 hover:shadow-xl w-full">
                    {/* Header */}
                    <div className="flex justify-center mb-4 sm:mb-6">
                      <img
                        src={theme.logoImage1 ?? imagePath}
                        width={120}
                        height={72}
                        alt="Logo"
                        className="object-contain w-20 h-12 sm:w-24 sm:h-14 md:w-28 md:h-16 lg:w-32 lg:h-20"
                      />
                    </div>

                    <h1 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-[#1f2c2b] uppercase mb-3 sm:mb-4 text-center sm:text-left">
                      Enter Your OTP
                    </h1>

                    <div className="mb-4 sm:mb-6 p-3 sm:p-4 bg-[#f5f5f5] rounded-lg">
                      <div className="flex flex-wrap items-center gap-1.5 sm:gap-2 justify-center sm:justify-start">
                        <span className="text-xs sm:text-sm lg:text-base font-bold text-[#1f2c2b]">
                          3 SIMPLE STEPS:
                        </span>
                        <span className="text-xs sm:text-xs lg:text-sm text-[#6a7b76]">
                          Enter phone number
                        </span>
                        <span className="text-[#4B975B] text-sm sm:text-base">→</span>
                        <span className="text-xs sm:text-xs lg:text-sm text-[#6a7b76]">
                          Get OTP
                        </span>
                        <span className="text-[#4B975B] text-sm sm:text-base">→</span>
                        <span className="text-xs sm:text-xs lg:text-sm text-[#6a7b76]">
                          Play & Win
                        </span>
                      </div>
                    </div>

                    {/* OTP Input */}
                    <div className="mb-4">
                      <label className="block text-xs sm:text-sm lg:text-base font-medium text-[#1f2c2b] mb-2">
                        Enter 4-digit OTP
                      </label>

                      <div className="flex flex-col sm:flex-row lg:flex-row gap-2 sm:gap-3">
                        {/* OTP Input Box */}
                        <div className="flex items-center flex-1 border-2 border-[#4B975B] rounded-lg px-3 sm:px-4 py-2.5 sm:py-3 bg-white">
                          <input
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength={4}
                            className="flex-1 outline-none bg-transparent text-xs sm:text-sm lg:text-base text-[#1f2c2b] placeholder-gray-400 disabled:opacity-50 disabled:cursor-wait"
                            placeholder="Enter OTP"
                            value={otp}
                            onChange={e => {
                              const value = e.target.value.replace(/\D/g, '');
                              if (value.length <= 4) {
                                setOtp(value);
                              }
                            }}
                            disabled={isVerifying}
                            onKeyDown={e => {
                              if (e.key === "Enter" && !isVerifying && otp) {
                                e.preventDefault();
                                onVerify();
                              }
                              const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
                              const isControlKey = e.ctrlKey || e.metaKey || e.altKey;
                              const isAllowedKey = allowedKeys.includes(e.key) || /^\d$/.test(e.key);
                              if (!isAllowedKey && !isControlKey) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>

                        {/* Verify OTP Button */}
                        <button
                          type="button"
                          onClick={e => {
                            e.preventDefault();
                            onVerify();
                          }}
                          disabled={!otp || isVerifying}
                          className="py-2.5 sm:py-3 px-4 sm:px-6 bg-gradient-to-r from-[#4B975B] to-[#ACC992] text-white text-xs sm:text-sm lg:text-base font-semibold rounded-lg hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                        >
                          {isVerifying ? "Verifying..." : "Verify OTP"}
                        </button>
                      </div>
                    </div>

                    {/* Error Message */}
                    {isError && (
                      <div className="mt-2 text-xs sm:text-sm text-red-600">
                        Incorrect OTP. Please try again.
                      </div>
                    )}

                    <div className="flex items-start gap-2 mb-4 sm:mb-6">
                      <p className="text-xs sm:text-sm text-[#6a7b76] mb-2">
                        {timer > 0 ? `Request another OTP in ${showTime(timer)} secs` : "Didn't receive OTP?"}
                      </p>
                      {timer === 0 && (
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            onSend();
                          }}
                          className="text-[#4B975B] hover:underline cursor-pointer font-medium text-[10px] sm:text-xs lg:text-sm"
                        >
                          Resend OTP
                        </span>
                      )}
                    </div>
                  </div>
                ) : (

                  <div className="bg-white border-3 border-[#4B975B] rounded-xl p-4 sm:p-6 md:p-7 lg:p-8 flex flex-col justify-around h-full transition-all duration-300 hover:shadow-xl w-full">
                    {/* Logo */}
                    <div className="flex justify-center mb-4 sm:mb-6">
                      <img
                        src={theme.logoImage1 ?? imagePath}
                        width={120}
                        height={72}
                        alt="Logo"
                        className="object-contain w-20 h-12 sm:w-24 sm:h-14 md:w-28 md:h-16 lg:w-32 lg:h-20"
                      />
                    </div>
                    {/* Main Title */}
                    <h1 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-[#1f2c2b] uppercase mb-3 sm:mb-4 text-center sm:text-left">
                      Start Playing in Less Than 30 Secs 🚀
                    </h1>

                    {/* Steps Info */}
                    <div className="mb-4 sm:mb-6 p-3 sm:p-4 bg-[#f5f5f5] rounded-lg">
                      <div className="flex flex-wrap items-center gap-1.5 sm:gap-2 justify-center sm:justify-start">
                        <span className="text-xs sm:text-sm lg:text-base font-bold text-[#1f2c2b]">
                          3 SIMPLE STEPS:
                        </span>
                        <span className="text-xs sm:text-xs lg:text-sm text-[#6a7b76]">
                          Enter phone number
                        </span>
                        <span className="text-[#4B975B] text-sm sm:text-base">→</span>
                        <span className="text-xs sm:text-xs lg:text-sm text-[#6a7b76]">
                          Get OTP
                        </span>
                        <span className="text-[#4B975B] text-sm sm:text-base">→</span>
                        <span className="text-xs sm:text-xs lg:text-sm text-[#6a7b76]">
                          Play & Win
                        </span>
                      </div>
                    </div>

                    {/* Form */}
                    <Form
                      onSubmit={e => {
                        e.preventDefault();
                        if (isCheck && phone && /^\d{10}$/.test(phone)) {
                          onSend();
                        }
                      }}
                    >
                      <div className="mb-4">
                        <label className="block text-xs sm:text-sm lg:text-base font-medium text-[#1f2c2b] mb-2">
                          Phone Number
                        </label>

                        <div className="flex flex-col sm:flex-row lg:flex-row gap-2 sm:gap-3">
                          {/* Phone Input */}
                          <div className="flex items-center flex-1 border-2 border-[#4B975B] rounded-lg px-3 sm:px-4 py-2.5 sm:py-3 bg-white">
                            <span className="text-[#4B975B] font-semibold mr-2 text-sm sm:text-base">
                              +91
                            </span>
                            <input
                              type="text"
                              placeholder="Enter 10-digit phone number"
                              value={phone}
                              maxLength={10}
                              disabled={isSendingOtp}
                              className="flex-1 outline-none bg-transparent text-xs sm:text-sm lg:text-base text-[#1f2c2b] placeholder-gray-400 disabled:opacity-50 disabled:cursor-wait"
                              onChange={e => {
                                const value = e.target.value.replace(/\D/g, '');
                                if (value.length <= 10) {
                                  setPhone(value);
                                }
                              }}
                              onKeyDown={e => {
                                if (e.key === "Enter" && !isSendingOtp) {
                                  e.preventDefault();
                                  if (isCheck && phone && /^\d{10}$/.test(phone)) {
                                    onSend();
                                  }
                                }
                              }}
                            />
                          </div>

                          {/* Send OTP Button */}
                          <button
                            onClick={e => {
                              e.preventDefault();
                              if (isCheck && phone && /^\d{10}$/.test(phone) && !isSendingOtp) {
                                onSend();
                              }
                            }}
                            type="button"
                            disabled={!isCheck || !phone || !/^\d{10}$/.test(phone) || isSendingOtp}
                            className="py-2.5 sm:py-3 px-4 sm:px-6 bg-gradient-to-r from-[#4B975B] to-[#ACC992] text-white text-xs sm:text-sm lg:text-base font-semibold rounded-lg hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                          >
                            {isSendingOtp ? "Sending..." : "Send OTP"}
                          </button>
                        </div>

                        {/* Error Message */}
                        {isInValidPhone && (
                          <div className="mt-2 text-xs sm:text-sm text-red-600">
                            {errorMsg || "Please enter a valid 10-digit phone number"}
                          </div>
                        )}
                      </div>
                    </Form>

                    {/* Consent Checkbox */}
                    <FormGroup check className="flex items-start gap-2 mb-4 sm:mb-6">
                      <Label check className="flex items-start gap-2 cursor-pointer">
                        <Input
                          type="checkbox"
                          onChange={HandleCheckbox}
                          checked={isCheck}
                          className="mt-0.5 sm:mt-1"
                        />
                        <span className="form-check-sign" />
                        <span className="text-[10px] sm:text-xs lg:text-sm text-[#1f2c2b] leading-relaxed">
                          By proceeding, you agree to WNNR's{" "}
                          <span
                            onClick={(e) => {
                              e.preventDefault();
                              setShowTermAndCondition(true);
                            }}
                            className="text-[#4B975B] hover:underline cursor-pointer font-medium text-[10px] sm:text-xs lg:text-sm"
                          >
                            Terms and Conditions
                          </span>
                          {" "}and{" "}
                          <span
                            onClick={(e) => {
                              e.preventDefault();
                              setShowPrivacyPolicy(true);
                            }}
                            className="text-[#4B975B] hover:underline cursor-pointer font-medium text-[10px] sm:text-xs lg:text-sm"
                          >
                            Privacy Policy
                          </span>
                          . We promise not to spam you.
                        </span>
                      </Label>
                    </FormGroup>

                    {/* Footer Links */}

                  </div>
                )}
              </div>
              <div className="w-full lg:basis-[55%] flex">
                <div className="w-full h-full flex items-center justify-center">
                  <img
                    src="/login-page.png"
                    className="w-full h-auto max-h-full object-contain rounded-xl"
                    alt="Promo banner"
                    style={{
                      border: "3px solid #EAF0D5"
                    }}
                  />
                </div>
              </div>
            </div>
            {/* </Container> */}
            <section className="py-10 lg:py-16">
              {/* Section Header */}
              <h2 className="font-plus-jakarta font-extrabold text-2xl lg:text-4xl text-[#1f2c2b] mb-8 lg:mb-12 text-left">
                Play Your Way to Rewards
              </h2>

              {/* Desktop & Tablet Timeline (md and up) */}
              <div className="hidden md:block">
                {/* Timeline with dots and connecting line */}
                <div className="relative mb-6">
                  <div className="relative grid grid-cols-5 gap-4 pb-8">
                    {/* Horizontal connecting line */}
                    <div className="absolute top-0 left-2 right-2 h-[2px] bg-[#1f2c2b] z-0" />

                    {steps.map((step, idx) => (
                      <div key={idx} className="relative">
                        {/* Dot */}
                        <div className="absolute top-0 left-0 -translate-y-1/2 w-4 h-4 bg-white border-[3px] border-[#1f2c2b] rounded-full z-10" />
                        {/* Step label above dot */}
                        <div className="absolute -top-8 left-0 font-plus-jakarta text-sm font-semibold text-[#1f2c2b] whitespace-nowrap">
                          {step.label}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Step cards */}
                <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
                  {steps.map((step, idx) => (
                    <div
                      key={idx}
                      className="bg-white rounded-xl p-3 shadow-md hover:shadow-lg transition-shadow duration-200 border border-gray-100"
                    >
                      {/* Icon */}
                      <div className="mb-3">
                        <img
                          src={step.icon}
                          alt={step.title}
                          className="w-12 h-12 object-contain"
                        />
                      </div>
                      {/* Title */}
                      <h3 className="font-plus-jakarta font-bold text-base lg:text-lg text-[#1f2c2b] mb-2 leading-tight">
                        {step.title}
                      </h3>
                      {/* Description */}
                      <p className="font-plus-jakarta text-sm text-[#6a7b76] leading-relaxed">
                        {step.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Mobile Timeline (below md) */}
              <div className="md:hidden">
                <div className="relative">
                  {/* Vertical connecting line */}
                  <div className="absolute left-4 top-2 bottom-8 w-[2px] bg-[#1f2c2b] z-0" />

                  {/* Steps */}
                  <div className="space-y-6">
                    {steps.map((step, idx) => (
                      <div key={idx} className="relative pl-12">
                        {/* Dot */}
                        <div className="absolute left-[13px] top-1 w-3.5 h-3.5 bg-white border-[3px] border-[#1f2c2b] rounded-full z-10" />

                        {/* Step label */}
                        <div className="font-plus-jakarta text-sm font-semibold text-[#1f2c2b] mb-3">
                          {step.label}
                        </div>

                        {/* Step card */}
                        <div className="bg-white rounded-xl p-4 shadow-md border border-gray-100">
                          {/* Icon */}
                          <div className="mb-3">
                            <img
                              src={step.icon}
                              alt={step.title}
                              className="w-10 h-10 object-contain"
                            />
                          </div>
                          {/* Title */}
                          <h3 className="font-plus-jakarta font-bold text-base text-[#1f2c2b] mb-2 leading-tight">
                            {step.title}
                          </h3>
                          {/* Description */}
                          <p className="font-plus-jakarta text-sm text-[#6a7b76] leading-relaxed">
                            {step.desc}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>
          </div>
          <PopUp
            visible={showTermAndCondition}
            onOk={() => setShowTermAndCondition(false)}
            title={"Terms and Conditions"}
            onCancel={() => setShowTermAndCondition(false)}
          >
            <PopupWrapper>
              <div className="p-4 sm:p-6 md:p-8 rounded-lg text-left">
                {/* <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-[#1f2c2b] mb-4">
                  WNNR Platform - User Terms & Conditions
                </h2> */}
                <div className="space-y-6">
                  <div>
                    <h3 className="text-base sm:text-lg font-semibold text-[#4B975B] mb-2">
                      1. Eligibility
                    </h3>
                    <ul className="text-sm sm:text-base text-[#6a7b76]">
                      <li>Users must be 18 years of age or older to enter the contest.</li>
                      <li>Participation is open only to Indian residents. The Platform may ask for supporting documents during the process</li>
                      <li>Employees of Dabur, associated partners, and their immediate family members are not eligible to play.</li>
                      <li>Entry to all games is free. There is no transaction required to enter the contest. Any SMS/message asking for financial information is deemed fraudulent.</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-semibold text-[#4B975B] mb-2">
                      2. Account Registration & Usage
                    </h3>
                    <ul className="text-sm sm:text-base text-[#6a7b76]">
                      <li>Users must complete accurate and truthful registration to access games, features, and rewards.</li>
                      <li>Only one account per user is allowed.</li>
                      <li>Dabur reserves the right to suspend or terminate accounts found to violate these terms.</li>
                      <li>Incomplete or inaccurate profiles will not be eligible for rewards, even if the user has won.</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-semibold text-[#4B975B] mb-2">
                      3. Code of Conduct
                    </h3>
                    <ul className="text-sm sm:text-base text-[#6a7b76]">
                      <li>Users must participate fairly and not act in a dishonest, fraudulent, or disruptive manner.</li>
                      <li>Any attempt to tamper with or game the platform, including the use of bots or cheats, will result in immediate disqualification and account termination.</li>
                      <li>Offensive, abusive, or threatening language or behavior towards any person is strongly prohibited.</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-semibold text-[#4B975B] mb-2">
                      4. Prizes and Rewards
                    </h3>
                    <ul className="text-sm sm:text-base text-[#6a7b76]">
                      <li>Winners must provide valid identification to claim rewards.</li>
                      <li>Dabur reserves the right to substitute or withdraw any prize at its discretion and is not liable for any incorrect, fraudulent representation by users.</li>
                      <li>Prizes are non-transferable and cannot be exchanged for cash.</li>
                      <li>Rewards are valid for 7 Days (Including Saturday and Sunday), post which unclaimed or unused rewards will expire and cannot be used for redemption.</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-semibold text-[#4B975B] mb-2">
                      5. Data Privacy & Security
                    </h3>
                    <ul className="text-sm sm:text-base text-[#6a7b76]">
                      <li>By using the platform, users consent to Dabur's collection and use of personal data as outlined in Dabur’s Privacy Policy and in compliance with Indian data protection laws.</li>
                      <li>Data will not be shared with third parties except as required for the fulfillment of rewards or as mandated by law.</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-semibold text-[#4B975B] mb-2">
                      6. Limitation of Liability
                    </h3>
                    <ul className="text-sm sm:text-base text-[#6a7b76]">
                      <li>Dabur is not liable for technical issues, unauthorized intervention, system failures, or any events beyond its control.</li>
                      <li>Users indemnify Dabur and its partners against all claims or losses arising from participation in games, including personal injury or property damage.</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-semibold text-[#4B975B] mb-2">
                      7. Platform Rights & Amendments
                    </h3>
                    <ul className="text-sm sm:text-base text-[#6a7b76]">
                      <li>Dabur reserves the right to change, suspend, or cancel any aspect of the platform at any time without prior notice.</li>
                      <li>The company may modify these T&Cs and will update users via platform communication or email.</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-semibold text-[#4B975B] mb-2">
                      8. Dispute Resolution
                    </h3>
                    <ul className="text-sm sm:text-base text-[#6a7b76]">
                      <li>All disputes will be subject to the exclusive jurisdiction of the courts in India.</li>
                      <li>In case of grievances related to prizes, users may reach out to Dabur’s designated customer support via the in-game form under Contact Us.</li>
                      <li>Support is available between Monday to Friday from 9:30 AM to 5 PM.</li>
                      <li>Response from support usually takes a maximum of 2 hours to 48 hours, depending on the complexity of the issue.</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-semibold text-[#4B975B] mb-2">
                      9. Acceptance
                    </h3>
                    <ul className="text-sm sm:text-base text-[#6a7b76]">
                      <li>Participation and continued use of the WNNR platform constitute acceptance of these T&Cs.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </PopupWrapper>
          </PopUp>
          <PopUp
            visible={showConsentForm}
            onOk={() => setShowConsentForm(false)}
            title={"Consent"}
            onCancel={() => setShowConsentForm(false)}
          >
            <PopupWrapper>
              <div className="wrapper-content">
                {/* ...consent form content... */}
                <p>
                  By submitting this form and participating in
                  win.daburshop.com’s raffles, games, and promotional
                  activities, you agree to receive marketing communications
                  from WNNR and Dabur India Limited. By checking the box
                  below and providing your details, you explicitly consent to:
                </p>
                {/* ...rest of the content remains unchanged... */}
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={consent}
                      onChange={e => HandleConsent(e)}
                    />
                    <span className="form-check-sign" />
                    <p>
                      I consent to receive marketing communications from
                      WNNR and Dabur, as outlined in this form.
                      You may opt out at any time by clicking the "unsubscribe"
                      link in any email or by adjusting your communication
                      preferences within the WNNR platform. For more details on
                      how your data is used and protected, please refer to our{" "}
                      <span
                        onClick={() => setShowPrivacyPolicy(true)}
                        className="terms-link"
                      >
                        Privacy Policy
                      </span>{" "}
                      below.
                    </p>
                  </Label>
                </FormGroup>
                <div>
                  <button
                    className="rounded-sm bg-gradient-to-r font-semibold from-[#4B975B] to-[#ACC992] text-white border-none px-5 py-2"
                    type="button"
                    onClick={() => setShowConsentForm(false)}
                  >
                    Accept
                  </button>
                </div>
              </div>
            </PopupWrapper>
          </PopUp>
          <PopUp
            visible={showPrivacyPolicy}
            onOk={() => setShowPrivacyPolicy(false)}
            title={"Privacy Policy"}
            onCancel={() => setShowPrivacyPolicy(false)}
            okText="No"
            cancelText="Yes"
          >
            <PopupWrapper>
              <PrivacyPolicy />
            </PopupWrapper>
          </PopUp>
          <PopUp
            visible={showContactUs}
            onOk={() => setShowContactUs(false)}
            title={"Contact Us"}
            onCancel={() => setShowContactUs(false)}
          >
            <PopupWrapper>
              <div className="wrapper-content">
                <Form>
                  <FormGroup>
                    <Label for="contactName">Name</Label>
                    <Input
                      type="text"
                      id="contactName"
                      value={contactForm.name}
                      onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
                      placeholder="Enter your name"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="contactEmail">Email</Label>
                    <Input
                      type="email"
                      id="contactEmail"
                      value={contactForm.email}
                      onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
                      placeholder="Enter your email"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="contactMessage">Message</Label>
                    <Input
                      type="textarea"
                      id="contactMessage"
                      rows={4}
                      value={contactForm.message}
                      onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
                      placeholder="Enter your message"
                    />
                  </FormGroup>
                  <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <button
                      className="enter-btn"
                      type="button"
                      onClick={() => {
                        // Handle form submission here
                        console.log('Contact form submitted:', contactForm);
                        setShowContactUs(false);
                        setContactForm({ name: '', email: '', message: '' });
                      }}
                    >
                      Send Message
                    </button>
                  </div>
                </Form>
              </div>
            </PopupWrapper>
          </PopUp>
        </div>

      </div>
    </div >
  );
};

export default Login;
